import { useEffect } from 'react';
import getIsElFocusedById from '../../../../utils/getIsElFocusedById';
export const preventKeyUp = (e) => {
    [35, 36, 38, 40].includes(e.which) && e.preventDefault();
};
export const useKeyupPrevention = (id) => {
    const isListFocused = getIsElFocusedById(id);
    useEffect(() => {
        const addListener = () => window.addEventListener('keydown', preventKeyUp);
        const removeListener = () => window.removeEventListener('keydown', preventKeyUp);
        isListFocused ? addListener() : removeListener();
        return () => removeListener();
    });
};
export default useKeyupPrevention;
//# sourceMappingURL=useKeyUpPrevention.js.map